
window.Action_Alert = function(message, class_alert) {
    $('#action_alert').empty();
    $('#action_alert').append(`
        <div class="alert ${class_alert} alert-dismissible fade show pr-4" role="alert">
            <div class="row">
                <div class="col">
                    <strong>${message}</strong>
                </div>
                <div class="col col-auto px-0">
                    <button style="border: 0px; background:none; color:white;" type="button" class="btn-close pr-1" data-bs-dismiss="alert">
                        <i class="fas fa-times"></i>
                    </button>
                </div>
            </div>
        </div>
    `);
}

window.Action_Alert_Id = function(message, class_alert, id) {
    $(`#action_alert_${id}`).empty();
    $(`#action_alert_${id}`).append(`
        <div class="alert ${class_alert} alert-dismissible fade show pr-4" role="alert">
            <div class="row">
                <div class="col">
                    <strong>${message}</strong>
                </div>
                <div class="col col-auto px-0">
                    <button style="border: 0px; background:none; color:white;" type="button" class="btn-close pr-1" data-bs-dismiss="alert">
                        <i class="fas fa-times"></i>
                    </button>
                </div>
            </div>
        </div>
    `);
}
